/**
 * 主菜单。渲染到 #ui-root，点击按钮触发回调。
 */
export class MainMenu {
  /**
   * @param {HTMLElement} root
   * @param {object} callbacks
   * @param {() => void} callbacks.onStart
   * @param {() => void} callbacks.onLevelSelect
   */
  constructor(root, { onStart, onLevelSelect }) {
    this.root = root;
    this.onStart = onStart;
    this.onLevelSelect = onLevelSelect;
    this.el = null;
  }

  show() {
    this.hide();
    const panel = document.createElement('div');
    panel.className = 'panel main-menu';
    panel.innerHTML = `
      <h1>3D 重力迷宫</h1>
      <div class="btn-row">
        <button class="btn" data-action="start">开始游戏</button>
        <button class="btn secondary" data-action="select">关卡选择</button>
      </div>
    `;
    panel.querySelector('[data-action="start"]').addEventListener('click', () => this.onStart());
    panel.querySelector('[data-action="select"]').addEventListener('click', () => this.onLevelSelect());
    this.root.appendChild(panel);
    this.el = panel;
  }

  hide() {
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
  }
}
